export default "__VITE_ASSET__C04ZEU5F__"